import { generateHash } from '../../../../utils/caching/common/key-generator';

export const generateCombinedConfigHash = (userId: string, cloudId: string): number =>
	generateHash(`${userId}${cloudId}`);
